export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">投稿与合作</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">欢迎漫画作者、翻译组与合作伙伴联系我们</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-100 p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">投稿邮箱</div>
                <div className="text-sm font-medium text-foreground-800">submit@43423.com</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-600 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-briefcase-line text-xl"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">商务合作</div>
                <div className="text-sm font-medium text-foreground-800">biz@43423.com</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 text-secondary-600 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">反馈建议</div>
                <div className="text-sm font-medium text-foreground-800">feedback@43423.com</div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-sm text-foreground-600 mb-4">
                我们期待每一份优秀的漫画作品，也欢迎各类合作洽谈
              </p>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('about');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多关于我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}